export function authHeader() {
    let token = localStorage.getItem('token');

    if (token) {
        return {'Authorization': 'Bearer ' + token};
    } else {
        return {};
    }
}

export function isAuthenticated() {
    return localStorage.getItem('token') !== null;
}

export function isAdministrator() {
    let token = localStorage.getItem('token');
    let tokenParts = token.split('.');
    let tokenScope: Array<any> = JSON.parse(window.atob(tokenParts[1])).scopes;

    return token && tokenScope.filter((item) => {return item === 'SUPRASYS'}).length > 0;
}


// WEBPACK FOOTER //
// src/helpers/auth.helper.js